import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../../button/button.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FiltersFormComponent } from '../filters-form/filters-form.component';

@Component({
  selector: 'app-filters-dialog',
  standalone: true,
  imports: [ButtonComponent, FiltersFormComponent],
  templateUrl: './filters-dialog.component.html',
  styleUrl: './filters-dialog.component.scss',
})
export class FiltersDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);

  submit() {
    this.ref.close({
      action: 'submit',
    });
  }

  clearFilters() {
    this.ref.close({
      action: 'clear',
    });
  }

  close() {
    this.config.data.filterForm.reset();
    this.ref.close();
  }
}
